import React from "react";

export default function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="contentOfPrivacy">
        <h1>Privacy Policy</h1>
        <p>
          Welcome to BTC Japan, the online auction car trading and bidding
          website. At BTC Japan, we value your privacy and are committed to
          protecting your personal information. This Privacy Policy explains how
          we collect, use, disclose, and safeguard your personal data when you
          use our website.
        </p>
        <h2>Information We Collect</h2>
        <p>
          <strong>Personal Information:</strong> We may collect personal
          information from you, including but not limited to your name, email
          address, contact information, and account credentials when you create
          an account or make inquiries.
        </p>
        <p>
          <strong>Payment Information:</strong> When you make payments on our
          platform, we collect payment information, such as credit card details
          or other payment methods.
        </p>
        <p>
          <strong>Usage Data:</strong> We automatically collect information
          about how you use our website, including your IP address, browser
          type, device information, and the pages you visit.
        </p>
        <h2>How We Use Your Information</h2>
        <p>
          <strong>Improving Our Services:</strong> We use your information to
          provide, maintain, and improve our services, including our online
          auction and trading platform.
        </p>
        <h2>Data Retention</h2>
        <p>
          We will retain your personal information only for as long as necessary
          to fulfill the purposes for which it was collected and as required by
          applicable laws and regulations.
        </p>
        <h2>International Transfers</h2>
        <p>
          Your information may be transferred to and stored on servers located
          in countries outside of your own. These countries may have data
          protection laws that are different from your country's. By using our
          services, you consent to such transfers.
        </p>
        <p>
          <strong>Communication:</strong> We may use your contact information to
          send you updates, news, and information related to our services,
          provided you have opted to receive such communications.
        </p>
        <h2>Information Sharing and Disclosure</h2>
        <p>
          <strong>Third-Party Service Providers:</strong> We may share your
          information with trusted third-party service providers who assist us
          in operating our website, conducting our business, or servicing you,
          as long as those parties agree to keep this information confidential.
        </p>
        <p>
          <strong>Legal Requirements:</strong> We may disclose your information
          to government authorities or other third parties if required by law or
          in response to legal requests.
        </p>

        <p>
          <strong>Legal Requirements:</strong> We may disclose your information
          to government authorities or other third parties if required by law or
          in response to legal requests.
        </p>
        <h2>How Do we Use Our Cookies?</h2>
        <p>
          Like many websites on the Internet, our website uses cookies. Our
          cookies cannot and do not retrieve any other data from your hard drive
          or pass on computer viruses. If you are just browsing our website, a
          cookie identifies your browser and user id (and not your identity). If
          you place orders with us, we use cookies to assist in storing your
          preferences and recording other session information.
        </p>

        <h2>Updates to Privacy Policy</h2>
        <p>
          We may update our Privacy Policy to reflect changes in our practices
          or for other operational, legal, or regulatory reasons. You will be
          notified of any material changes to our Privacy Policy.
        </p>

        <h2>Questions or Concerns</h2>
        <p>
          If you have any questions or concerns about our Privacy Policy, please
          contact us at [your contact email].
        </p>

        <h2>Security</h2>
        <p>
          We take reasonable measures to protect your information from
          unauthorized access, disclosure, alteration, or destruction.
        </p>
      </div>
    </div>
  );
}
